const k = (c, s) => {
  const t = c;
  t.use = {};
  for (const e of Object.keys(t.getState()))
    t.use[e] = () => t((o) => o[e]);
  if (s)
    for (const e of Object.keys(s))
      t.use[e] = () => t(s[e]);
  return t;
}, S = (c, s) => {
  const t = c, e = t.getState();
  for (const o of s) {
    const r = e[o];
    if (!(!r || typeof r != "object")) {
      t.use[`${String(o)}`] = {
        _: () => t((n) => n[o])
      };
      for (const n of Object.keys(r))
        t.use[`${String(o)}`][n] = () => t((u) => {
          var f;
          return (f = u[o]) == null ? void 0 : f[n];
        });
    }
  }
  return t;
};
export {
  k as createSelectors,
  S as extendSelectors
};
